import { useQuery } from '@tanstack/react-query'

import { containerApi } from '../..'
import { FeatureFlags, GetFeatureFlagsResponse } from './getFeatureFlags.types'

// Consumers follow Pennant: a flag is active when its value is anything other
// than `false`, so the string "false" has to become a real `false`. Rich
// values ("red", "1", "no") are kept as they are.
export const toFeatureFlags = (raw: Record<string, unknown>): FeatureFlags =>
  Object.fromEntries(
    Object.entries(raw).map(([key, value]) => {
      const lower = String(value).toLowerCase()
      if (lower === 'true') return [key, true]
      if (lower === 'false') return [key, false]
      return [key, String(value)]
    })
  )

const getFeatureFlags = async () => {
  const response =
    await containerApi.get<GetFeatureFlagsResponse>('/features/me')
  return toFeatureFlags(response.data.data)
}

const GET_FEATURE_FLAGS_QUERY_KEY = 'getFeatureFlags'

// `cacheKey` is `${userId}:${organizationId}`; undefined disables the query.
export const useGetFeatureFlagsQuery = (cacheKey: string | undefined) => {
  return useQuery({
    queryKey: [GET_FEATURE_FLAGS_QUERY_KEY, cacheKey],
    queryFn: getFeatureFlags,
    enabled: !!cacheKey,
    // Flags are loaded once per app load, see useLoadFeatureFlags.
    staleTime: Infinity
  })
}
